import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { ANDROID_PLATFORM, IOS_PLATFORM } from '../../constants';
import { translateText } from '../../utils';
import { DestinationList } from '../controls';
import css from './AdvancedSettings.css';
import { sitePropType } from './propTypes';

const DestinationsSection = ({
    site,
    platformFamilyName,
    apsalarEnabled,
    singularLinksEnabled,
    readOnly,
    translate,
    onDestinationChange,
}) => {
    const showDeepLinkDestinations =
        apsalarEnabled &&
        ([IOS_PLATFORM, ANDROID_PLATFORM, 'windows'].includes(platformFamilyName) ||
            (site._published === false && !!site.platform));

    return (
        <section className={css.formSection}>
            <h4>
                <Translate id="STATIC.PAGES.APPS_CONFIGURATION.DESTINATIONS" />
            </h4>
            {singularLinksEnabled && (
                <div className={css.richText}>
                    {translate('STATIC.PAGES.APPS_CONFIGURATION.DESTINATIONS_SUBHEADER', null, {
                        renderInnerHtml: true,
                    })}
                </div>
            )}
            <DestinationList
                title={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.DESTINATION_URLS" />}
                emptyText={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.DEFAULT_STORE_URL" />}
                destinations={site.destinations?.regular}
                includeDefaultRow
                defaultRowLabel={translateText(translate, 'STATIC.PAGES.APPS_CONFIGURATION.DEFAULT_STORE_URL')}
                defaultRowTitle={translateText(
                    translate,
                    'STATIC.PAGES.APPS_CONFIGURATION.DEFAULT_STORE_URL_DISABLED_TOOLTIP'
                )}
                disabled={readOnly}
                onChange={destinations => onDestinationChange('regular', destinations)}
            />
            {showDeepLinkDestinations && (
                <DestinationList
                    title={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.DEEP_LINK_TARGETS" />}
                    emptyText={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.NO_DEEP_LINKS_CONFIGURED" />}
                    destinations={site.destinations?.deeplink}
                    disabled={readOnly}
                    onChange={destinations => onDestinationChange('deeplink', destinations)}
                />
            )}
            {apsalarEnabled && platformFamilyName === IOS_PLATFORM && !singularLinksEnabled && (
                <DestinationList
                    title={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.IOS_UNIVERSAL_LINK_TARGETS" />}
                    emptyText={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.NO_IOS_UNIVERSAL_LINKS_CONFIGURED" />}
                    destinations={site.destinations?.ios_universal_link}
                    disabled={readOnly}
                    onChange={destinations => onDestinationChange('ios_universal_link', destinations)}
                />
            )}
        </section>
    );
};

DestinationsSection.propTypes = {
    apsalarEnabled: PropTypes.bool.isRequired,
    onDestinationChange: PropTypes.func.isRequired,
    platformFamilyName: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    singularLinksEnabled: PropTypes.bool.isRequired,
    site: sitePropType.isRequired,
    translate: PropTypes.func.isRequired,
};

export default DestinationsSection;
